import React from 'react';
import { Icon } from 'elements';

import styles from './loader.scss';

const Loader = ({ color="gray" }) => (
  <Icon className={styles.loading} name="icon-loading" color={color} />
);

export { Loader };



// WEBPACK FOOTER //
// ./src/elements/loader/loader.js